import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Using MemoryRouter instead HashRouter to "forbid" URL route change
import { MemoryRouter, Redirect, Route, Switch } from 'react-router-dom';
import Home from './HomeScreen';
import ReservationSuccessful from './ReservationSuccessfulScreen';
import Flights from './flights/FlightsScreen';
import Passengers from './passengers/PassengersScreen';
import Seats from './seats/SeatsScreen';
import Meals from './meals/MealsScreen';
import Review from './review/ReviewScreen';
import NoRoute from './NoRoute';
import Notifications from '../components/notifications/Notifications';
import '../assets/css/App.css';

/**
 * ## Redux imports
 */
import * as devAuthActions from '../redux/actions/DevAuthActions';
import { actions as routerActions } from 'react-router-redux';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../redux/selectors/Index';

/**
 * ## Redux boilerplate
 */
const actions = [ devAuthActions, routerActions ];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    activeStep: selectors.global.activeStep(state.global),
    routing: state.routing,
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

class Router extends Component {
  static propTypes = { actions: PropTypes.object, activeStep: PropTypes.string };

  constructor (props) {
    super(props);

    const { activeStep } = props;
    let newActiveStep = activeStep && activeStep.indexOf('http') !== -1 ? '' : activeStep;
    this.state = { activeStep: newActiveStep };
    this.props.actions.getSessionToken();
  }

  componentDidCatch (error) {
    console.error('Component did catch error: ', error);
  }

  componentWillReceiveProps (props) {
    const { activeStep } = props;
    if (activeStep && activeStep.indexOf('http') !== -1) {
      return;
    }
    this.setState({ activeStep });
  }

  render () {
    let newActiveState = this.props.activeStep;
    const { activeStep } = this.state;

    if (newActiveState && newActiveState.indexOf('http') !== -1) {
      var newTab = window.open(newActiveState, '_blank');
      if (newTab) newTab.focus();
    }

    return (
      <div className='App' id='App'>
        <MemoryRouter>
          <div className='app'>
            <Notifications />
            <div className='app-body'>
              <div className='main main-content'>
                <Switch>
                  <Route
                    exact
                    path='/'
                    render={props =>
                      activeStep === '' || activeStep === '/' ? (
                        <Home {...props} />
                      ) : (
                        <Redirect to={activeStep} />
                      )
                    }
                  />
                  <Route
                    exact
                    path='/flights'
                    render={props =>
                      activeStep === 'flights' ? (
                        <Flights {...props} />
                      ) : (
                        <Redirect to={activeStep} />
                      )
                    }
                  />
                  <Route
                    exact
                    path='/passengers'
                    render={props =>
                      activeStep === 'passengers' ? (
                        <Passengers {...props} />
                      ) : (
                        <Redirect to={activeStep} />
                      )
                    }
                  />
                  <Route
                    exact
                    path='/seats'
                    render={props =>
                      activeStep === 'seats' ? <Seats {...props} /> : <Redirect to={activeStep} />
                    }
                  />
                  <Route
                    exact
                    path='/meals'
                    render={props =>
                      activeStep === 'meals' ? <Meals {...props} /> : <Redirect to={activeStep} />
                    }
                  />
                  <Route
                    exact
                    path='/review'
                    render={props =>
                      activeStep === 'review' ? <Review {...props} /> : <Redirect to={activeStep} />
                    }
                  />
                  <Route
                    exact
                    path='/reservationsuccessful'
                    render={props =>
                      activeStep === 'reservationsuccessful' ? (
                        <ReservationSuccessful {...props} />
                      ) : (
                        <Redirect to={activeStep} />
                      )
                    }
                  />

                  <Route component={NoRoute} />
                </Switch>
              </div>
            </div>
          </div>
        </MemoryRouter>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Router);



// WEBPACK FOOTER //
// ./src/containers/Router.js